import React from 'react';
import capacitacionHome from '../../img/capacitacionHome.webp';
import { Link } from 'react-router-dom';
const Capacitacion = () => {
   return (
      <div className="bg-latitud animated fadeIn" >
         <div className="container section">
            <div className="row">
               <div className="center-vertical">
                     <div className="col s12 m12 l6 x6 center">
                        <img src={capacitacionHome} className="circle responsive-img" height="300" width="300"/>
                     </div>
                     <div className="col s12  m12 l6  x6 center text-white">
                        <strong style={{"font-size":"24px"}}>Curso Online</strong><br/><br/>
                        <strong style={{"font-size":"20px"}}>Aprendé sobre Ergonomía y Prevención e Inciendios</strong><br/><br/>
                        <strong style={{"font-size":"18px"}}>Iniciá aquí la Capacitación y obtené tu certificado</strong><br/><br/><br/>
                        <Link to={"prevencion"} className="btn btn-large waves-effect waves-light text-gray  white pulse" >Iniciar
                           <i className="material-icons right">send</i>
                        </Link>
                     </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Capacitacion